import { getCookie, setCookie } from "../../util";
import { required, sameAs, email, minLength } from "vuelidate/lib/validators";
import auth from "../../auth";
import { getEventRecommendationsBasedOnLocation } from "../../api";
import FeatureCard from "./landingComponents/FeatureCard.vue";
import MainFeatureCard from "./landingComponents/MainFeatureCard.vue";
const keks = getCookie("acceptedCookie");

export default {
  name: "Landing",
  components: {
    FeatureCard,
    MainFeatureCard
  },
  data() {
    return {
      bmcIcon: require("@/assets/landing-icons/bmc-logo.png"),
      kircIcon: require("@/assets/landing-icons/ki-readiness-check_logo.png"),
      leaIcon: require("@/assets/landing-icons/lea_logo.png"),
      loggedIn: auth.loggedIn(),
      personalRecommendations: [],
      sending: false,
      error: false,
      form: {
        firstname: null,
        lastname: null,
        gender: null,
        email: "",
        letter: false
      },
      cookieAccept: true,
      newsletter: false
    };
  },
  validations: {
    form: {
      firstname: {
        required,
        minLength: minLength(3)
      },
      lastname: {
        required,
        minLength: minLength(3)
      },
      gender: {
        required
      },
      email: {
        required,
        email
      }
    }
  },
  created() {
    if (keks === "true") {
      this.cookieAccept = false;
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    validateData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.newsletter = false;
        this.signupForNewsletter();
      }
    },
    signupForNewsletter() {
      this.sending = true;
      auth
        .registerForNewsletter(
          this.email,
          this.firstname,
          this.lastname,
          this.gender
        )
        .then(() => {
          this.sending = false;
        })
        .catch(err => {
          console.log(err);
          this.sending = false;
          this.error = true;
        });
    },
    setBeenHere() {
      setCookie("acceptedCookie", "true", 365);
      location.reload();
    },
    getRecommendations() {
      getEventRecommendationsBasedOnLocation().then(res => {
        if (res && res.length > 0) {
          this.personalRecommendations = res;
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/landing/landing.js